'use client';

import { useState } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import { analytics } from '@/lib/analytics';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Home', href: '/homepage' },
    { label: 'Services', href: '/services-overview' },
    { label: 'Reviews', href: '/customer-reviews' },
  ];

  const navLinks = [
    { label: 'Services', href: '/services-overview' },
    { label: 'Reviews', href: '/customer-reviews' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavClick = (destination: string) => {
    analytics.trackNavigation(destination, 'Header Navigation');
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-card shadow-brand ${className}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link href="/homepage" className="flex items-center space-x-3 transition-smooth hover:opacity-80" onClick={() => handleNavClick('Home')}>
            <AppImage
              src="/assets/images/b37fa040-c4d5-47fb-ac00-191e53f206e6-1769810300759.JPG"
              alt="Crystal Clean Logo"
              width={240}
              height={80}
              className="h-20 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-foreground hover:text-primary hover:bg-accent rounded-md transition-smooth"
                onClick={() => handleNavClick(item.label)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/get-quote"
              className="ml-4 px-6 py-2.5 bg-green-600 text-white font-semibold rounded-full hover:bg-green-700 transition-smooth shadow-brand-sm btn-bubbly"
              onClick={() => handleNavClick('Get Quote')}
            >
              Get Free Quote
            </Link>
          </nav>

          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 text-foreground hover:text-primary hover:bg-accent rounded-md transition-smooth"
            aria-label="Toggle mobile menu"
          >
            <Icon name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={24} />
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-card border-t border-border">
          <nav className="container mx-auto px-4 py-4 space-y-1">
            {navigationItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => {
                  handleNavClick(item.label);
                  setIsMobileMenuOpen(false);
                }}
                className="block px-4 py-3 text-sm font-medium text-foreground hover:text-primary hover:bg-accent rounded-md transition-smooth"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/get-quote"
              onClick={() => {
                handleNavClick('Get Quote');
                setIsMobileMenuOpen(false);
              }}
              className="block px-4 py-3 text-center bg-green-600 text-white font-semibold rounded-full hover:bg-green-700 transition-smooth mt-4 btn-bubbly"
            >
              Get Free Quote
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;